import React from "react";
import WebcamCapture from "../../components/WebcamCapture/WebcamCapture";

function Ocr() {
  return (
    <div>
      <WebcamCapture />
    </div>
  );
}

export default Ocr;
